webpackJsonpcentroprofits_promo([18],{

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fox, $) {
    'use strict';

    __webpack_require__(152)(fox);

    fox.registerWidget('SitePage_404', {
        configure: function configure() {
            this.registerOptions('', {
                template: 'sitepage_404'
            });

            this.callParent('configure', arguments);
        }
    });
};

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_404", [["div",{"class":"_layout-width"},[["div",{"class":"wrapper-404 _flex _col-n _c-v-center _c-h-center"},[["div",{"class":"_flex _row-n _r-v-center"},[["span",{"class":"number-404"},[["textNode",{"text":"4"}]]],["textNode",{"text":" "}],["img",{"class":"brand-logo-404 _m-h-15","src":"" + __webpack_require__(153) + ""}],["textNode",{"text":" "}],["span",{"class":"number-404"},[["textNode",{"text":"4"}]]]]],["h2",{"class":"title-404 _fs-21 _m-t-15 _ta-c"},[["textNode",{"text":" Sorry, this page isn’t available "}]]],["p",{"class":"desc-404 _m-t-20 _m-b-30 _ta-c"},[["textNode",{"text":" The link you followed may be broken, or the page may have been removed "}]]],["a",{"class":"btn adaptive secondary","href":"/"},[["textNode",{"text":"Home"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

module.exports = fox._r("images/svg/brand-logo.svg", __webpack_require__.p + "images/svg/brand-logo.svg");

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(151)(fox);

/***/ })

});


// WEBPACK FOOTER //
// chunks/ch.18.js